import { render, staticRenderFns } from "./mypage-deposit-list-type.vue?vue&type=template&id=56f3e5ec&scoped=true&"
import script from "./mypage-deposit-list-type.vue?vue&type=script&lang=js&"
export * from "./mypage-deposit-list-type.vue?vue&type=script&lang=js&"
import style0 from "./mypage-deposit-list-type.vue?vue&type=style&index=0&id=56f3e5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3e5ec",
  null
  
)

export default component.exports